// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3VWCF","list":"PatternAutocomplete_list__328Dr"};